<template>
  <div>
    <v-app-bar flat color="transparent" class="mt-4">
      <v-img
        :src="brandLogoGradient"
        contain
        max-height="40"
        max-width="252"
      ></v-img>
      <v-spacer></v-spacer>
      <v-btn depressed rounded color="primary" @click="logout">Salir</v-btn>
    </v-app-bar>
  </div>
</template>
<script>
import AppConfig from '@/constants/app-config'
export default {
  name: 'the-header',
  props: {},
  data() {
    return {
      drawer: null,
      changingStatus: false,
      brand: AppConfig.brand,
      brandLogoGradient: AppConfig.brandLogoGradient
    }
  },
  methods: {
    logout() {
      this.$router.push({ name: 'logout' })
    }
  }
}
</script>
